import { useEffect, useState } from "react";

export function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("losta_cookies")) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);
  const decide = (v) => {
    localStorage.setItem("losta_cookies", v);
    setShow(false);
  };
  if (!show) return null;
  return (
    <div className="fixed bottom-4 inset-x-4 sm:left-auto sm:right-6 sm:max-w-md z-[70]" data-testid="cookie-consent">
      <div className="card-lux rounded-2xl p-5 backdrop-blur-xl bg-[#0F1118]/95">
        <p className="text-sm text-slate-300 font-light leading-relaxed">
          Nous utilisons uniquement les cookies nécessaires au bon fonctionnement du site. Aucune donnée n'est
          partagée à des fins publicitaires.
        </p>
        <div className="mt-4 flex gap-3">
          <button
            onClick={() => decide("all")}
            className="btn-gold rounded-full px-5 py-2 text-xs uppercase tracking-wider"
            data-testid="cookie-accept"
          >
            Accepter
          </button>
          <button
            onClick={() => decide("essential")}
            className="btn-ghost rounded-full px-5 py-2 text-xs uppercase tracking-wider"
            data-testid="cookie-essential"
          >
            Essentiels uniquement
          </button>
        </div>
      </div>
    </div>
  );
}
